import * as React from "react";

/**
 * Small inline chip shown on objects created via the Mock Data tool,
 * or on data sections returning mock/placeholder values.
 * Orange to be visually distinct from the blue "Simulated" chip on products.
 */
export function MockedChip({
  label = "Mocked",
  title = "Created from mock data for testing",
}: {
  label?: string;
  title?: string;
}) {
  return (
    <span
      title={title}
      style={{
        fontSize: 11,
        fontWeight: 600,
        padding: "1px 7px",
        borderRadius: 9999,
        background: "#FFF7ED",
        color: "#C2410C",
        flexShrink: 0,
        border: "1px solid #FED7AA",
        cursor: "default",
        userSelect: "none",
      }}
    >
      {label}
    </span>
  );
}
